import { render, staticRenderFns } from "./Museum.vue?vue&type=template&id=3910737c&scoped=true"
import script from "./Museum.vue?vue&type=script&lang=js"
export * from "./Museum.vue?vue&type=script&lang=js"
import style0 from "./Museum.vue?vue&type=style&index=0&id=3910737c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3910737c",
  null
  
)

export default component.exports